// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-form-remind-password{position:relative;border-radius:2px;width:100%;background:#E5E5E5;box-shadow:0px 0px 20px 0px rgba(0,0,0,0.75);padding:25px}.ac-form-remind-password__back-url{display:block;text-align:center;margin-top:15px}\n", ""]);
// Exports
module.exports = exports;
